import React from 'react';
import useComponentVisible from 'utils/visible/visible';
import './AppSelect.scss';
import { IAppSelectProps } from './IAppSelectProps';
import { ReactComponent as ArrowDownIcon } from './icons/arrowdown.svg';
import { ReactComponent as XIcon } from 'assets/img/x-filled.svg';
import FlexyPopOnMe from 'elements/flexypoponme';
import { FormGroupInputElement } from 'components/PageBuilder/PageBuilderFormPreview/PageBuilderFormPreview';
import PerfectScrollbar from 'react-perfect-scrollbar';

const AppSelect: React.FC<IAppSelectProps> = (props) => {
  const { disableValueClick = false } = props;

  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  React.useEffect(() => {
    if (props.hideDropdownRef) {
      props.hideDropdownRef.current = () => setIsComponentVisible(false);
    }
  }, []);

  React.useEffect(() => {
    if (!isComponentVisible && props.onDropDownClosed) {
      props.onDropDownClosed();
    }
  }, [isComponentVisible, props.onDropDownClosed])

  const onFocus = () => {
    if (props.onFocus) {
      props.onFocus();
    }
  }

  const closeSelectPopUp = () => {
    setTimeout(() => {
      setIsComponentVisible(false);
    }, 100)
  }

  const childrenWithProps = React.Children.map(props.children, child => {
    // Checking isValidElement is the safe way and avoids a
    // typescript error too.
    if (React.isValidElement(child)) {
      //@ts-ignore
      return React.cloneElement(child, { closeSelectPopUp, });
    }
    return child;
  });

  return (
    <div className={`groupapp-select-container ${props.containerClassName ? props.containerClassName : ''} ${props.disabled ? 'AppSelectdisabled' : ''}`}>
      <div className="groupapp-select-input-container">
        {props.label ? <p className="groupapp-select-input-label" style={props.labelStyles ? props.labelStyles : {}}>{props.label}{props.markRequired && (<span className="groupapp-select-input-label-required-asterisk">*</span>)}{props.extraLabelMarkup ? props.extraLabelMarkup : <></>}</p> : <></>}
        {props.valueElement ? (
          <div
            className={`groupapp-select-input-wrapper ${isComponentVisible ? 'highlighted' : ''} ${!props.label ? 'no-label' : ''} ${props.selectInputWarpperStyles}`}
            onChange={() => { }}
            onClick={() => {
              onFocus();
              if (props.disabled || disableValueClick || isComponentVisible) {
                return;
              }
              setIsComponentVisible(true);
              if(props.onDropDownOpened) {
                props.onDropDownOpened();
              }
            }}
          >{props.valueElement && props.valueElement}</div>
        ) : props.useTippy ? (
          <FlexyPopOnMe
          component={(
            <div
              className={`groupapp-select-popup--tippy ${!props.label ? 'no-label' : ''} ${props.tippyContainerClassName ? props.tippyContainerClassName : ''}`}
              style={props.popupStyles}
            >
              {childrenWithProps}
            </div>
          )}
          closeOnComponentClick
          placement={props.tippyPlacement ? props.tippyPlacement : undefined}
          hideTippyArrow
          >
               {props.pageBuilderView ? (
                <FormGroupInputElement
                  design={props.pageBuilderViewDesign}
                  className={`${!props.label ? 'no-label' : ''} ${props.noCaret ? 'no-caret' : ''
                  } ${props.cursorPointer ? 'cursor-pointer' : ''
                  } ${
                    props.inputClassName ? 
                    props.inputClassName : ''
                  }`}
                onClick={() => {
                  onFocus();

                  if (props.disabled) {
                    return;
                  }
                }}
                value={props.value}
                onChange={props.onChangeValue}
                placeholder={props.placeholder}
                disabled={props.disabled}
                readOnly={props.readOnly}
                style={props.inputStyles ? props.inputStyles : undefined}
                />
               ) : (
                <input
                  type="text"
                  className={`groupapp-select-input-input ${!props.label ? 'no-label' : ''} ${props.noCaret ? 'no-caret' : ''
                    } ${props.cursorPointer ? 'cursor-pointer' : ''
                    } ${
                      props.inputClassName ? 
                      props.inputClassName : ''
                    }`}
                  onClick={() => {
                    onFocus();

                    if (props.disabled) {
                      return;
                    }
                  }}
                  value={props.value}
                  onChange={props.onChangeValue}
                  placeholder={props.placeholder}
                  disabled={props.disabled}
                  readOnly={props.readOnly}
                  style={props.inputStyles ? props.inputStyles : undefined}
                />
               )}
          </FlexyPopOnMe>
        ) : (
          <input
            type="text"
            className={`groupapp-select-input-input ${!props.label ? 'no-label' : ''} ${props.noCaret ? 'no-caret' : ''
              } ${props.cursorPointer ? 'cursor-pointer' : ''
              } ${
                props.inputClassName ? 
                props.inputClassName : ''
              } ${
                props.disabled ?
                'disabled' :
                ''
              }`}
            onClick={() => {
              onFocus();

              if (props.disabled) {
                return;
              }
              setIsComponentVisible(true);
              if(props.onDropDownOpened) {
                props.onDropDownOpened();
              }
            }}
            value={props.value}
            onChange={props.onChangeValue}
            placeholder={props.placeholder}
            disabled={props.disabled}
            style={props.inputStyles ? props.inputStyles : undefined}
            readOnly={props.readOnly}
            onFocus={props.onInputFocused ? props.onInputFocused : undefined}
            onBlur={props.onInputBlurred ? props.onInputBlurred : undefined}
          />
        )}
        <span className={`groupapp-select-input-icon ${!props.label ? 'no-label' : ''} ${
          props.inputIconClassName ? props.inputIconClassName : ''
        }`}
          onClick={() => {
            onFocus();

            if (props.disabled) {
              return;
            }
            setIsComponentVisible(true);
            if(props.onDropDownOpened) {
              props.onDropDownOpened();
            }
          }}
          style={props.inputIconStyles}
        >
          <ArrowDownIcon />
        </span>

        <span
          className={`groupapp-select-input-xicon  ${props.XIconstyles && props.disabled ? props.XIconstyles : ''}`}
          onClick={() => {
            if(props.disableXIcon) {
              return;
            }
            onFocus();
            setIsComponentVisible(true);
            props.onRemoveSelectedValue();
          }}
          style={{
            display: isComponentVisible ? 'none' : ''
          }}
        >
          <XIcon />
        </span>
      </div>
      {isComponentVisible && (
        <>
          {
            window.location.pathname === '/settings/teams'
              ?
              <div
                className={`groupapp-select-popup ${!props.label ? 'no-label' : ''}`}
                ref={ref}
              >
                <PerfectScrollbar
                  options={{
                    wheelPropagation: false,
                  }}
                  style={props.popupStyles}
                >
                  {childrenWithProps}
                </PerfectScrollbar>
              </div>
              :
              <div
                className={`groupapp-select-popup ${!props.label ? 'no-label' : ''}`}
                ref={ref}
                style={props.popupStyles}
              >
                {childrenWithProps}
              </div>
          }
        </>
      )}
    </div>
  )
}

export default AppSelect;